/* hs-eslint ignored failing-rules */

/* eslint-disable promise/catch-or-return */
'use es6';

import quickFetch from 'quick-fetch';
import { buildErrorResponse } from 'hub-http/adapters/adapterUtils';
import { responseError } from 'hub-http/helpers/response';
export default ((name, retry) => {
  const earlyMetaRequest = quickFetch.getRequestStateByName(name);
  if (!earlyMetaRequest) return null;
  return new Promise((resolve, reject) => {
    earlyMetaRequest.whenFinished(result => {
      resolve(result);
      quickFetch.removeEarlyRequest(name);
    });
    earlyMetaRequest.onError((xhr, statusCode) => {
      quickFetch.removeEarlyRequest(name);

      if (statusCode === 404 || statusCode === 400) {
        const errorReponse = buildErrorResponse(xhr, `early request '${name}' failed`, statusCode);
        reject(responseError(errorReponse, `early request '${name}' failed`, statusCode));
      } else {
        retry().then(resolve, reject);
      }
    });
  });
});